import React, {useState, useEffect} from "react";
import Tabs from "@common/Tabs";
import Tab from "@common/Tab";
import {SchoolRounded, GroupsRounded} from "@mui/icons-material";
import {Route, Switch, useLocation} from "wouter";
import ClassDetailsStudents from "./ClassDetailsStudents";
import SchoolClasses from "./SchoolClasses";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import SchoolUsers from "./SchoolUsers";
import ClassDetails from "./ClassDetails";
import BulkClassUpdate from "../schoolClasses/BulkClassUpdate/BulkClassUpdate";

const SchoolManagementTabs = props => {
    const BASE_URL = '/web/ui/view/classes'

    const TABS = {
        SCHOOL_CLASSES: { val: 0, hash: 'schoolClasses'},
        USERS: { val: 1, hash: 'schoolUsers'}
    };

    const [location, setLocation] = useLocation();
    const getInitialTabKey = () => {
        if (location === BASE_URL) {
            return TABS.SCHOOL_CLASSES.val;
        } else {
            const val = Object.values(TABS).find(tab => location.includes(`/${tab.hash}`))?.val;
            return val !== undefined ? val : TABS.SCHOOL_CLASSES.val;
        }
    };

    const [activeTabKey, setActiveTabKey] = useState(getInitialTabKey);
    const [activeClass, setActiveClass] = useState({});
    const {loadShortcutByUrl} = useCurrentShortcut();

    const handleChangeTab = (key) => {
        setActiveTabKey(key);
        const selectedTab = Object.values(TABS).find(tab => tab.val === parseInt(key));
        if (selectedTab) {
            const currentUrl = new URL(window.location.href);
            const queryString = currentUrl.search;
            setLocation(`/web/ui/view/classes/${selectedTab.hash}${queryString}`);
        }
    };

    useEffect(() => {
        if (activeClass.classId) setActiveTabKey(TABS.SCHOOL_CLASSES.val);
    }, [activeClass]);

    useEffect(() => {
        if(location === BASE_URL){
            loadShortcutByUrl('/web/ui/view/classes/schoolClasses');
            return;
        }

        const isTopLevelTab = Object.values(TABS).some(tab =>
            location === `${BASE_URL}/${tab.hash}`
        );

        if (isTopLevelTab) {
            const matchedTab = Object.values(TABS).find(tab =>
                location.includes(`/${tab.hash}`)
            );
            if (matchedTab && matchedTab.val !== activeTabKey) {
                setActiveTabKey(matchedTab.val);
            }
        }
    }, [location]);

    return (
        // If you add a route here, you need to add it to the navigation context breadcrumbMap so it knows what to do with it.
        <Switch>
            <Route path={`${BASE_URL}/schoolClasses/class/:classId`}>
                {(params) => <ClassDetails classIdParam={params.classId} />}
            </Route>
            <Route path={`${BASE_URL}/schoolClasses/class/:classId/classDetails`}>
                {(params) => <ClassDetailsStudents classIdParam={params.classId} />}
            </Route>
            <Route path={`${BASE_URL}/schoolClasses/bulkClassUpdate`}>
                <BulkClassUpdate exitMode={() => loadShortcutByUrl('/web/ui/view/classes/schoolClasses')} />
            </Route>
            <Tabs overrideKey={activeTabKey} variant="standard" onChange={handleChangeTab} contentClassName="margin-t--l" destroyOnHidden={true}>
                <Tab
                    tab={
                        <>
                            <SchoolRounded className={'margin-r--m'} />
                            <span className={'margin-r--m tabText'}>Classes</span>
                        </>
                    }
                    key={TABS.SCHOOL_CLASSES.val}
                    children={
                        <Route path={`${BASE_URL}/schoolClasses`}>
                            <SchoolClasses />
                        </Route>
                    }
                     data-gtm-value="classes-tab-classes"
                />
                <Tab
                    tab={
                        <>
                            <GroupsRounded className={'margin-r--m'} />
                            <span className={'margin-r--m tabText'}>Users</span>
                        </>
                    }
                    key={TABS.USERS.val}
                    children={
                        <Route path={`${BASE_URL}/schoolUsers`}>
                            <SchoolUsers />
                        </Route>
                    }
                    data-gtm-value="classes-tab-users"
                />
            </Tabs>
        </Switch>
    );
}

export default SchoolManagementTabs;